/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, { useContext } from "react";

import APPLICATION_ROUTER_INTERFACE from "@DATA/Router/Interfaces/Router";
import ApplicationRouterContext from "@Contexts/Router";

import PLAY_ICON from "@Images/136.Play.png";
import { NavLink } from "react-router-dom";


type QuizLinkProps = {
    EXPIRE: string;
    EXPIREPERIOD: number;
    TERMINALNO: string;
};


export const QuizLinkComponent: React.FC<QuizLinkProps> = ({
    EXPIRE, EXPIREPERIOD, TERMINALNO
}): JSX.Element | null => {

    const ROUTER: APPLICATION_ROUTER_INTERFACE = useContext(ApplicationRouterContext);
    const QUIZROUTE = ROUTER.AUTHENTICATED.SETTINGS.SETTINGS_MY_BHP_PAGE.QUIZ;

    var expirePeriodDate = new Date(EXPIRE);
    expirePeriodDate.setDate(expirePeriodDate.getDate() - EXPIREPERIOD)
    var isQuizLinkVisible = expirePeriodDate < new Date() || EXPIRE == undefined;

    if (!isQuizLinkVisible) return null;

    return (
        <NavLink to={{pathname: QUIZROUTE.QUIZDESC.URL, state:{terminalNo: TERMINALNO}}} title={"Przeprowadź szkolenie"}>
            <figure className={"m-0"}>
                <img src={PLAY_ICON} alt={``} height={50} />
                <figcaption >Przeprowadź szkolenie</figcaption>
            </figure>
        </NavLink>
    );
};


export default QuizLinkComponent;
